module.exports = __webpack_public_path__ + "static/no_notif-7d2c8e099cacbd0a941ba0d0c350a9e0.svg";